<template>
  <div class="wrapper" v-if="getCloseType(content,closed)" @click="clickLint(content)">
    <div class="no-inner-item">
      <bui-richcell
        class="rich-view"
       :contentArr="getContentList(content)"
       :keywordsArr="getKeyList(content)"
       textTheme="black"
      ></bui-richcell>
    </div>
    <img src="@/assets/close_new.png"
    class="tip-close-v-right2" @click="closeView" v-if="getShowClose(content)" />
        <!-- <img src="@/assets/close_new.png"
      class="tip-close"   alt /> -->
    <!-- </img> -->
  </div>
</template>
<script>

import ouiRichCell from '@/components/richCell.vue';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

// import NativeMsg from '@/base/NativeMsg';
// import JS from '@/base/JSTool';
/**
 * TipType为0时，用Tip（文字描述），TipType为1时，用TipIcon（图片地址）
 closeType 0 有关闭图标 可自动消失
 closeType 1 有关闭图标 不会自动消失
 closeType 2 没有关闭图标 不会自动消失
 Mode 2 没有关闭图标 可自动消失
 Mode 3 有关闭图标 不会自动消失
 Mode 0 没有关闭图标 不会自动消失
*/

export default {
  name: 'WarningqTip',
  components: {
    'bui-richcell': ouiRichCell,
  },
  props: {
    content: {
      type: Object,
      default: () => { },
    },
    clickEvent: {
      type: Function,
      default: () => {
      },
    },
    closeEvent: {
      type: Function,
      default: () => {
      },
    },
  },
  watch: {},
  data() {
    return {
      list: [],
      fundCode: '',
      fundType: '',
      closed: false,
    };
  },
  created() {
    setTimeout(this.configureCloseState, 30000);
    // NativeMsg.reg('refreshState', (res) => {
    //   if (res.state === 1) {
    //     // console.log('refreshState==========1');
    //     this.closed = false;
    //     setTimeout(this.configureCloseState, 30000);
    //   }
    // });
  },
  mounted() {},
  methods: {
    getstrList(item, key, hotkey) {
      if (!item[hotkey]) {
        return [item[key]];
      }
      if (item[hotkey].length === 0) {
        return [item[key]];
      }
      const val = `###${item[hotkey]}###`;
      const regS = new RegExp(item[hotkey], 'g');
      const con = item[key].replace(regS, val);
      const strs = con.split('###'); // 定义一数组
      return strs;
    },
    getContentList(richItem) {
      const tList = this.getstrList(richItem, 'Title', 'HotKey');
      const subtList = this.getstrList(richItem, 'SubTitle', 'SubHotKey');
      const allList = tList.concat(subtList);
      return allList;
    },
    getKeyList(richItem) {
      return [richItem.HotKey, richItem.SubHotKey];
    },
    render() {
    },
    configureCloseState() {
      if (this.getActionType(this.content.Mode) === '0') {
        this.closeView();
      }
    },
    getActionType(mode) {
      if (mode === '0') {
        return '2';
      }
      if (mode === '1') {
        return '0';
      }
      if (mode === '2') {
        return '0';
      }
      if (mode === '3') {
        return '1';
      }
      return '0';
    },
    closeView(e) {
      if (e) {
        e.stopPropagation();
      }
      this.closed = true;
      if (this.closeEvent) {
        this.closeEvent();
      }
    },
    getShowTip(item) {
      if (item.TipType) {
        if (item.TipType === '0') {
          return 1;
        }
        if (item.TipType === '3') {
          return 3;
        }
        if (item.TipType === '1') {
          return 0;
        }
      }
      return 0;
    },
    getShowClose(item) {
      if (this.getActionType(item.Mode) === '1') {
        return true;
      }
      return false;
    },
    getCloseType(item, closed) {
      if (closed) {
        return false;
      }
      if (item.Title.length === 0) {
        return false;
      }
      if (this.content) {
        if (this.content.show) {
          if (this.content.show === '1') {
            return true;
          }
        }
      }
      return true;
    },
    clickLint(item) {
      if (!item) {
        return;
      }
      if (!item.Link) {
        return;
      }
      const { LinkType, LinkTo } = item.Link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      if (this.clickEvent) {
        this.clickEvent();
      }
    },
    clickSingle() {
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  background: #fff7bc;;
}
.no-inner-item {
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  padding: 18px 50px 16px 0px;
}
.inner-item {
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  padding: 18px 50px 18px 30px;
}
.tip-item{
  // height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: 15px;
}
.rich-view {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 10px;
}
.text {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ff0000;
}

.tipredleftview{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.tipredleftps{
  width: 10px;
  height: 25px;
}
.tipredleft {
  position: absolute;
  margin-top: 25px;
  width: 25px;
  height: 25px;
  margin-left: 15px;
}
.tip-close-v-right2{
  border-radius: 0 12px 0 0;
  right: 25px;
  position:absolute;
  width: 42px;
  height: 34px;
}
.tip-close {
  width: 42px;
  height: 34px;
}
.tip-close-v{
 width: 42px;
  height: 34px;
}
.small-tag {
  border-radius: 4px;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  padding: 8px 4px;
  border: 2px solid;
  display: flex;
  flex-wrap: nowrap;
  word-break:keep-all
}
</style>
